/**
 * Adds a specified number of milliseconds to a given date string and returns the new Date object.
 *
 * @param {string} dateStr - The input date string (ISO format or any valid date string).
 * @param {number} milliseconds - The number of milliseconds to add.
 * @returns {Date} A new Date object representing the updated time.
 */
export function addMillisecondsToDate(dateStr: string, milliseconds: number): Date {
	const date = new Date(dateStr);
	return new Date(date.getTime() + milliseconds);
}
